import { Button } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import { useCallback } from "react";

type TableActionsProps = {
  id: string;
  setTaskIdToClose: React.Dispatch<React.SetStateAction<string | undefined>>;
};

export const TableActions = ({ id, setTaskIdToClose }: TableActionsProps) => {
  const onClick = useCallback(
    (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
      e.stopPropagation();
      setTaskIdToClose(id);
    },
    [id, setTaskIdToClose],
  );

  return (
    <Button
      icon={<CheckOutlined />}
      shape="round"
      size="small"
      onClick={onClick}
    >
      Close Task
    </Button>
  );
};
